
const KEYS = [
  'dataSource', 'label', 'hint', 'placeholder', 'title',
];

export default (form = {}, l10n = {}) => {
  const translatedForm = Object.assign({}, form);

  Object.values(form).forEach((value) => {
    KEYS.forEach((key) => {
      if (Array.isArray(value[key]) && typeof value[key] !== 'object') {
        const l10nValue = value[key].map(item => (
          item && item.includes('l10n') ? l10n[item.split('.')[1].toUpperCase()] : item
        ));
        value[key] = l10nValue || value[key]; // eslint-disable-line
      } else if (value[key] && value[key].includes('l10n')) {
        let l10nValue = l10n[value[key].split('.')[1].toUpperCase()];
        if (key === 'dataSource') {
          l10nValue = l10nValue.split(',');
        }
        value[key] = l10nValue || value[key]; // eslint-disable-line
      }
    });
  });

  return translatedForm;
};
